export const ConvertDatetime = (value: string) => {
  const localDate = new Date(value).toLocaleString('en-GB');
  const time1 = localDate.substring(12, 20);
  const time2 = localDate.substring(0, 10);

  return `${time1} ${time2}`;
};
